require('../../style/base.css');
require('../../overlay/index.css');
require('../../info/index.css');
require('../../icon/index.css');
require('../../image/index.css');
require('../../popup/index.css');
require('../../loading/index.css');
require('../../swipe/index.css');
require('../../swipe-item/index.css');
require('../../image-preview/index.css');
require('../index.css');


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/uploader/style/index.js
// module id = 129
// module chunks = 1